import React from "react";
import ContactDetails from "../../../_components/Contacts/ContactDetails";
import {
    getSupplierById, updateSupplier, createSupplier,
    getSupplierCompanyNames,
} from "../../../_services/contact.service";

export default function SupplierDetails() {
    return (
        <ContactDetails
            type="Supplier"
            fetchById={getSupplierById}
            updateItem={updateSupplier}
            createItem={createSupplier}
            fetchCompanyNames={getSupplierCompanyNames}
        />
    );
}